import api from "@/api/api-v2-config";

export async function getDeliveryNotesListAxios(id) {    
    return await api.get("deliverynotess/" + id + "/client");
}

export async function deleteDeliveryNotesAxios(id) {    
    return await api.delete("deliverynotess/" + id);
}

export async function postDeliveryNotesAxios(deliverynotes) {    
    return await api.post("deliverynotess", deliverynotes);
}

export async function putDeliveryNotesAxios(deliverynotes) {    
    return await api.put("deliverynotess", deliverynotes);
}

export async function getDeliveryNotesByIDAxios(id) {    
    return await api.get("deliverynotess/" + id + "/invoice");
}

export async function getAllDeliveryNotesListAxios() {
    return await api.get("deliverynotess"); 
}
export async function getDeliverySignatureIDAxios(id) {    
    return await api.get("deliverynotess/signature/"+ id);
}

export async function postDeliverySignatureAxios(payload) {    
    return await api.post("deliverynotess/signature", payload);
}
